import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const FORM_ID = 'editUserForm';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  isProviderAdmin: PropTypes.bool.isRequired,
  isUser: PropTypes.bool.isRequired,
  renderCheckbox: PropTypes.func.isRequired,
  renderSelect: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitFunction: PropTypes.func.isRequired,
  userTypes: PropTypes.object.isRequired,
};

const UserEdit = ({
  handleSubmit,
  invalid,
  isSuperAdmin,
  isProviderAdmin,
  isUser,
  renderCheckbox,
  renderSelect,
  submitting,
  submitFunction,
  userTypes,
}) => (
  <div className="container form-only">
    <Form id={FORM_ID} onSubmit={handleSubmit(submitFunction.bind(this))}>
      <fieldset>
        <div className="card card-block">
          <h4 className="card-title">Edit User Account</h4>
          <div className="form-group row">
            <div className="col-md-6">
              <Field
                name="firstName"
                type="text"
                component={InputField}
                label="First Name"
                placeholder="First name"
                autoFocus
              />
            </div>
            <div className="col-md-6">
              <Field
                name="lastName"
                type="text"
                component={InputField}
                label="Last Name"
                placeholder="Last name"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-6">
              <Field
                name="phoneNumber"
                type="text"
                component={InputField}
                label="Phone Number"
                placeholder="(   ) ___ - ____ ext ___"
              />
            </div>
            <div className="col-md-6">
              {!isUser && (isProviderAdmin || isSuperAdmin) ? (
                <Field
                  name="accessLevel"
                  component={renderSelect}
                  label="Access Level"
                  userTypes={userTypes}
                />
              ) : null}
            </div>
            <div className="col-md-6">
              {!isUser && isSuperAdmin ? (
                <Field
                  name="isPrimary"
                  type="checkbox"
                  component={renderCheckbox}
                  label="Set As Primary?"
                />
              ) : null}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary btn-back"
            onClick={browserHistory.goBack}
          >
            Cancel
          </button>&nbsp;&nbsp;
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkButtonDisabled(invalid, submitting)}
          >
            Submit Changes
          </button>
        </div>
      </fieldset>
    </Form>
  </div>
);

UserEdit.propTypes = propTypes;

export default UserEdit;
